import { FC } from 'react';
import Icon from '../../assets/images/warning.png';

type Props = {
  errorMessage: string;
};

const ConfirmEmailError: FC<Props> = ({ errorMessage }) => {
  return (
    <div className='text-center col-lg-8 offset-lg-2 mt-10'>
      <img src={Icon} alt='Email Notification' width='60px' />
      <h3 className='mt-2 mb-2'>Email Confirmation Failed</h3>
      <p> {errorMessage}</p>
    </div>
  );
};

export default ConfirmEmailError;
